import React from 'react';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import DashboardPopover from '../../../../components/dashboards/components/Popover';
import { config } from '../../../../components/dashboards/config';

const Style = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--size-lg) 14px;
  background: white;
  border-radius: 4px;
  box-shadow: 0px 5px 11px -1px rgba(0, 0, 0, 0.18);
  flex: 1;
  gap: 4px;
  justify-content: space-between;
  height: 100%;
  text-align: center;

  .flex {
    justify-content: center;
    gap: 5px;
  }

  .label {
    margin-bottom: 0px;
    font-size: 14px;
    font-weight: 600;
    color: #1D2939;
  }

  .action {
    font-size: 14px;
    font-weight: 500;
    color: #1570EF;
    cursor: pointer;
  }

  .value {
    margin-bottom: 0px;
    font-size: 20px;
    font-weight: 700;
    color: #344054;

    svg {
      color: #1570EF;
      width: 12px;
      height: 12px;
    }
  }
`;

const getValue = (type, value) => {
  switch (type) {
    case 'percentage':
      return `${value}%`;
    default:
      return value || '-'
  }
}

const DetailsWidget = ({
  label = '',
  value = 0,
  type = 'number',
  onClick = () => { },
  tooltip,
  hasActions = true,
  loading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Style>
      <div className="flex">
        <h1 className="label">{label}</h1>
        {!!tooltip && (
          <Tooltip
            rootClassName='dashboard-tooltip'
            title={(
              <DashboardPopover
                title={tooltip.title}
                body={tooltip.body}
              />
            )}
          >
            <InfoCircleOutlined
              style={{
                color: config.TOOLTIP_ICON_COLOR,
                fontSize: config.TOOLTIP_ICON_SIZE,
              }}
            />
          </Tooltip>
        )}
      </div>
      <h2 className="value">
        {loading ?
          <LoadingOutlined />
          : (hasActions ? getValue(type, value) : value)}
      </h2>
      {hasActions && (
        <span onClick={onClick} className="action">
          {t('View Details')}
        </span>
      )}
    </Style>
  );
}

export default DetailsWidget;
